import { colors, font, spacing } from '@chegg-ui/theme'
import styled from 'styled-components'

export const EditorWrapperContainer = styled.div<{ isEditorDisabled: boolean }>`
  // Prosemirror classes
  .ProseMirror {
    line-height: 2.5rem;
    overflow-wrap: anywhere;
    p {
      color: ${colors.grey900};
    }

    &:focus-visible,
    *:focus-visible {
      outline: none;
    }
  }

  *::-moz-selection {
    /* Code for Firefox */
    background-color: ${colors.grey100};
  }

  *::selection {
    background-color: ${colors.grey100};
  }

  background: ${({ isEditorDisabled }) => (isEditorDisabled ? colors.grey100 : 'unset')};

  // This css is required when using the Tiptap placeholder extension
  // https://tiptap.dev/api/extensions/placeholder#additional-setup
  .ProseMirror p.is-editor-empty:first-child::before {
    color: ${colors.grey300};
    content: attr(data-placeholder);
    height: 0;
    float: left;
    pointer-events: none;
  }

  border-radius: 10px 10px 0 0;
  padding: ${spacing.px16} ${spacing.px16} 0 ${spacing.px16};
  font-size: ${font.size.px18};
  font-weight: ${font.weight.medium};
  line-height: 35px;
  text-align: left;
  overflow: auto;
  margin-top: ${spacing.px24};
  overscroll-behavior: contain;
  height: calc(
    100vh - 300px
  ); /* subtracting height + top padding/margin of header, editor header, and footer */

  grammarly-extension {
    display: none;
  }
`
